<evc-nav-button type="cta" size="xxl" variant="round" (click)="gotoReportTemplateBuilder()" *callToAction disabled="{isOnPremise}">
  <span class="top-cta-label">
    {{ callToActionLabel.label | optionalAsync }}
  </span>
  <evc-svg-icon size="md" [icon]="callToActionLabel.icon"></evc-svg-icon>
</evc-nav-button>
<div class="content">
  <div class="reports-title-container">
    <h1>{{ "topMenuBar.reports" | translate }}</h1>
    <evc-status-indicator status="info" *ngIf="reportList" [text]="reportList.total.toString()" class="status-indicator" />
  </div>
  <div fxLayout="row" fxLayoutAlign="space-between start">
    <div class="search-div dense-text-field" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px">
      <p-iconfield>
          <p-inputicon class="pi pi-search" />
          <input type="text" pInputText placeholder="Search" [formControl]="searchTextControl" (keyup.enter)="initReportList()" />
      </p-iconfield>
      <div fxLayout="row" class="filter-div" fxLayoutGap="12px">
        <evc-nav-button class="filter-btn" type="secondary" variant="square" leftIcon="filter" size="sm" (click)="openAddFilterDialog()">
          {{ "inspectionreportlist.filter" | translate }}
        </evc-nav-button>
        <div fxLayout="row wrap" fxLayoutAlign="start" fxLayoutGap="12px">
          <ng-container *ngFor="let filter of selectFilters">
            <div class="filter-content filter-button">
              <span class="label">
                {{ filter.label }}
                <mat-icon class="clear" (click)="filterClear(filter)">clear</mat-icon>
              </span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div class="entire-contents">
    <div matSort matSortDisableClear #reportCardContents matSortActive="date" matSortDirection="asc">
      <div class="header-row" *ngIf="isReportFound">
        <div
          mat-sort-header="name"
          class="header-cell name"
          (click)="changeSortFilter(false)"
          (mouseover)="hoveredSortType = 'name'"
          (mouseleave)="hoveredSortType = null"
        >
          <span>
            {{ "inspectionreportlist.name" | translate }}
          </span>
          <img id="no-sort-name" *ngIf="activeSort !== 'name' && hoveredSortType !== 'name'" src="assets/icons/sprite/no_sort.svg" />
        </div>
        <div class="header-cell in-use"></div>
        <div
          mat-sort-header="date"
          class="header-cell date"
          (click)="changeSortFilter(true)"
          (mouseover)="hoveredSortType = 'date'"
          (mouseleave)="hoveredSortType = null"
        >
          <span>
            {{ "inspectionreportlist.date" | translate }}
          </span>
          <img id="no-sort-date" *ngIf="activeSort !== 'date' && hoveredSortType !== 'date'" src="assets/icons/sprite/no_sort.svg" />
        </div>
        <div class="header-cell inspector">
          {{ "inspectionreportlist.inspector" | translate }}
        </div>
        <div class="header-cell menu-container"></div>
      </div>
      <div
        class="table-content"
        [ngClass]="{ desktop: isDesktop }"
        infiniteScroll
        [infiniteScrollDistance]="getDynamicScrollDistance()"
        [infiniteScrollThrottle]="300"
        [scrollWindow]="false"
        (scrolled)="onLoadNext()"
        #scrollContainer
      >
        <ng-container>
          <app-inspection-report-list-item
            *ngFor="let report of reportDataSource?.data; let i = index"
            class="report-list"
            [report]="report"
            [tenantUsers]="tenantUsers"
            (deleteReport)="deleteReport($event)"
          />
        </ng-container>
        <div class="record-loading-area">
          <img
            *ngIf="isReportFound && this.reportList?.items.length < this.reportList?.total && isRecordsLoading"
            class="loading"
            src="assets/images/loading.gif"
            alt=""
          />
          <div *ngIf="!isReportFound && !isRecordsLoading" class="no-inspection-found" fxLayout="row" fxLayoutAlign="center none">
            {{ "inspectionreportlist.noreportFound" | translate }}.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
